import { ACTIONS, LEVEL_COUNT, SINGLE_PART_LEVELS } from 'a/pictureThis/data/constants';

export const initialState = {
  isOnBoardingReplay: false,
  levelsCompleted: Array(LEVEL_COUNT - 1).fill(false),
  onboardingCompleted: [false, false],
};

const sessionData = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.REPLAY_ONBOARDING:
      return {
        ...state,
        isOnBoardingReplay: true,
      };
    case ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnBoardingReplay: false,
        onboardingCompleted: payload > SINGLE_PART_LEVELS
          ?
          [state.onboardingCompleted[0], true]
          :
          [true, state.onboardingCompleted[1]], // marking corresponding onboarding level as complete
      };
    case ACTIONS.END_ONBOARDING:
      return {
        ...state,
        isOnBoardingReplay: false,
      };
    case ACTIONS.MASTER_THIS_LEVEL:
      return {
        ...state,
        levelsCompleted: state.levelsCompleted.map(
          (mastered, i) => mastered || payload.levelIndex - 1 === i, // marking target level as complete
        ),
      };
    default:
      return state;
  }
};

export default sessionData;

// selectors

export const getIsOnboardingReplay = state => state.isOnBoardingReplay;

export const getLastLevelUnlocked = state => getLevelsMastered(state).reduce(
  (levelsMastered, isLevelMastered) => {
    if (isLevelMastered) {
      return levelsMastered + 1;
    }
    return levelsMastered;
  }, 0,
);

export const getLevelsMastered = state => state.levelsCompleted;

export const getLevelsCompleted = state => state.levelsCompleted;

export const getIsLevelMastered = (state, level) =>
  state.levelsCompleted[level - 1];

export const getLevelsCompletedCount = state => getLevelsMastered(state).reduce(
  (levelsCount, isComplete) => {
    if (isComplete) {
      return levelsCount + 1;
    }
    return levelsCount;
  }, 0,
);
